import styled from 'styled-components';

export const SearchBanner = styled.div`
    display: flex;
    gap:24px; 
      @media screen and (max-width:991px) {
         flex-wrap: wrap;   
          
  }
      
`;

export const LeftBanner = styled.div`
    width: 100%;
    max-width: 690px;
 @media screen and (max-width:991px) {
      padding-top: 52px;
         max-width: inherit;
}
`;

export const LogoTitle = styled.div`
    display: flex;
    gap:15px;
  @media screen and (max-width:575px) {
   flex-wrap: wrap;   
  }
`;

export const LogoImage = styled.div`
    background: #F7F7F7;
    box-shadow: 0px 10px 20px #0000001A;
    border-radius: 10px;
    opacity: 1;
    width: 120px;
    min-width:120px;
    height: 120px;
    img{
        width:100%;
        height:100%;
        object-fit:cover;
    } 
`;
export const TitleSection = styled.div``;

export const SearchTitle = styled.h1`
    color: #333333;
    font-family: "Jost", sans-serif;
    font-size:22px;
    font-weight: 600;
    line-height: 30px;
    margin-bottom: 15px;
    cursor: pointer;
`;

export const AdoptionsList = styled.ul`
    display: flex;
    list-style: none;
    padding: 0 0 15px 0;
    margin: 0;
    gap: 10px;
    
`;

export const AdoptionsItem = styled.li`
    color: #33A7AE;
    font-family: "Jost", sans-serif;
    font-size:16px;
    font-weight: 500;
    line-height:23px;
    display: flex;
    gap: 10px;
    align-items: center;
    cursor: pointer;
`;

export const IconSpan = styled.span``;

export const ReviewStart = styled.span`
    color: #000000;
    font-family: "Jost", sans-serif;
    font-size:14px;
    font-weight: 500;
    line-height: 20px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    column-gap: 5px;
`;
export const StarIcon = styled.span`
    display: flex;
`;
export const Review = styled.div`
    display: flex;
    align-items: center;
    gap: 6px;
`;
export const ButtonSection = styled.div`
    display: flex;
    gap: 15px;
    margin-top: 16px;
     @media screen and (max-width:575px) {
       flex-wrap: wrap;   
    }
    .share_donate_btn{
        padding: 11px 29px;
    }
    
    button{
       @media screen and (max-width:575px) {
         width:100%;
       }
    }
    
    .write-yellow-btn{
        padding: 11px 23px;
    }
`;

export const WarmCost = styled.div`
    background: #FFFFFF 0% 0% no-repeat padding-box;
    box-shadow: 0px 5px 30px #0000001A;
    border-radius: 15px;
    display: flex;
    align-items: center;
    padding: 18px 15px;
    margin-top: 40px;
    gap: 32px;
      @media screen and (max-width:1199px) {
       flex-wrap: wrap;   
    }
`;
export const WarmCostLeft = styled.div`
    width: 100%;
    max-width: 318px;
    position: relative;
   @media screen and (max-width:1199px) {
     max-width: inherit;
   }

    &:after {
        position: absolute;
        background: #E1E1E1;
        height: 100%;
        width: 2px;
        content: "";
        right: -17px;
        top: 0;
        @media screen and (max-width:1199px) {
          display:none; 
        }  
    }
`;
export const WarmCoastTile = styled.h2`
   color: #33A7AE;
   font-family: "Jost", sans-serif;
   font-size:20px;
   font-weight: 600;
   line-height:30px;
   margin-bottom:5px;
`;
export const SmallText = styled.p`
    color: #333333;
    font-family: "Jost", sans-serif;
    font-size:14px;
    font-weight: 400;
    line-height:22px;
`;
export const DollarWrapper = styled.div`
    display: flex;
    gap: 9px;
    flex-wrap: wrap;
`;
export const OtherBtn = styled.div`
     color: #000000;
    font-family: "Jost", sans-serif;
    font-size:14px;
    font-weight: 500;
    line-height: 20px;
    // background:#01606F ;
    box-shadow: 0px 5px 10px #0000000D;
    background: rgb(51 167 174 / 10%);
    border-radius: 10px;
    padding: 14px 16px;
    display: inline-flex;
    max-width: 56px;
    text-align: center;
    justify-content: center;
`;
export const WarnCostRight = styled.div`
    flex:1;
`;

export const RightBanner = styled.div`
    width: 100%;
    max-width: 500px;

    @media screen and (max-width: 991px){
        max-width: 100%;
    }

   .image-gallery-left-nav,
   .image-gallery-right-nav,
   .image-gallery-fullscreen-button{
    display:none;
   }

   .image-gallery-slide-wrapper {
        background: #FFFFFF;
        box-shadow: 0px 20px 20px #0000001A;
        border-radius: 10px;
        padding: 10px;
    }
    .image-gallery-thumbnail.active, .image-gallery-thumbnail:focus {
        outline: none;
        border: 4px solid #337ab7;
        border: 2px solid #FFFFFF;
        border-radius: 10px !important;
        opacity: 1;
    }
.image-gallery-thumbnails {
       background: #211d1a;
        border-radius: 10px;
        opacity: 1;
        backdrop-filter: blur(50px);
        -webkit-backdrop-filter: blur(50px);
        max-width: 453px;
        width: 100%;
        padding: 9px 8px;
       margin: -100px auto 0px;
    @media screen and (max-width:575px) {
       max-width: 250px;
    } 
}
.image-gallery-thumbnail-image{
    border-radius: 10px !important;
   height: 55px;
   
}

.image-gallery-thumbnail{
    width: 70px;
    height: 59px;
    min-width: 70px;
    border: 2px solid transparent;
    border-radius: 10px;
    opacity: 0.8;
    &:hover {
        outline: none;
        border: 2px solid #fff;
        border-radius: 10px;
    }
} 
  .image-gallery-image{
     width: 480px !important;
     height: 320px !important;
     border-radius: 6px !important;
    }
`;